module.exports = {
    cvURL: 'https://drive.google.com/file/d/1-Rjtk-7pGh1uJieR8V_sX-IgVe_pHUdj/view',
    githubURL: 'https://github.com/leomoreno99',
    linkedinURL: 'https://www.linkedin.com/in/leomoreno99/',
    instagramURL: 'https://www.instagram.com/leo_moreno99/',
    wspNumber: '5493804261732',
    email: 'leomoreno330@gmail.com',
    githubPortfolioUrl: 'https://github.com/leomoreno99/leomoreno-portfolio'
  };
